import { FIELDS } from '@/pages/Inventory/constants';

const inventoryFields = [
  {
    cell: 'commands',
    width: 50,
  },
  {
    field: 'quantityAllocated',
    cell: 'formatSeparator',
    title: 'Allocated',
    width: 105,
  },
  {
    title: 'Qty To Pull',
    cell: 'qtyToPull',
    width: 105,
  },
  {
    field: 'partNumber',
    title: 'Part',
    width: 200,
  },
  {
    field: 'dateCode',
    title: 'Date Code',
    width: 120,
  },
  {
    field: 'lotCode',
    title: 'Lot Code',
    width: 100,
  },
  {
    field: 'revision',
    title: 'Revision',
    width: 100,
  },
  {
    field: 'conditionName',
    title: 'Condition',
    width: 150,
  },  
  {
    field: 'countryOfOriginName',
    title: 'Country of Origin',
    width: 150,
  },  
  {
    field: 'warehouseName',
    title: 'Warehouse',
    width: 150,
  },
  {
    field: 'location',
    title: 'Location',
    width: 150,
  },
  {
    title: '',
    cell: 'confirm',
    width: 100,
  },
];

export default inventoryFields;
